export default "__VITE_ASSET__0ca51bf1__"